const franchiseTheme = {
  footerSection: {
    background: `#121212`,
    backgroundImage: `#121212`,
    inputBackground: `rgba(255, 255, 255, 0.1)`,
    inputText: `#ffffff`,
    lightTextColor: `#ffffff`,
    filledButtonBGColor: '#19c7ff',
    pageLinksColor: `#ffffff`,
    poweredByTextColor: '#43484d',
    poweredbyBackgroundColor: '#ffffff',
    poweredbyDivider: 'none',
    white: `#ffffff`
  }
}
export default franchiseTheme



// WEBPACK FOOTER //
// ./src/constants/themeConstants/franchiseTheme.js